// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as OfflineRouteImport } from './routes/offline'
import { Route as NotificationsRouteImport } from './routes/notifications'
import { Route as ChatRouteImport } from './routes/chat'
import { Route as IndexRouteImport } from './routes/index'
import { Route as UserIdRouteImport } from './routes/user.$id'
import { Route as TopicIdRouteImport } from './routes/topic.$id'
import { Route as ProfileUserAgreementRouteImport } from './routes/profile.user-agreement'
import { Route as ProfileSettingsRouteImport } from './routes/profile.settings'
import { Route as ProfilePrivacyPolicyRouteImport } from './routes/profile.privacy-policy'
import { Route as ProfileEditRouteImport } from './routes/profile.edit'
import { Route as PostIdRouteImport } from './routes/post.$id'
import { Route as GroupIdRouteImport } from './routes/group.$id'
import { Route as DocumentIdRouteImport } from './routes/document.$id'

const OfflineRoute = OfflineRouteImport.update({
            id: '/offline',path: '/offline',getParentRoute: () => rootRouteImport
          })
const NotificationsRoute = NotificationsRouteImport.update({
            id: '/notifications',path: '/notifications',getParentRoute: () => rootRouteImport
          })
const ChatRoute = ChatRouteImport.update({
            id: '/chat',path: '/chat',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const UserIdRoute = UserIdRouteImport.update({
            id: '/user/$id',path: '/user/$id',getParentRoute: () => rootRouteImport
          })
const TopicIdRoute = TopicIdRouteImport.update({
            id: '/topic/$id',path: '/topic/$id',getParentRoute: () => rootRouteImport
          })
const ProfileUserAgreementRoute = ProfileUserAgreementRouteImport.update({
            id: '/profile/user-agreement',path: '/profile/user-agreement',getParentRoute: () => rootRouteImport
          })
const ProfileSettingsRoute = ProfileSettingsRouteImport.update({
            id: '/profile/settings',path: '/profile/settings',getParentRoute: () => rootRouteImport
          })
const ProfilePrivacyPolicyRoute = ProfilePrivacyPolicyRouteImport.update({
            id: '/profile/privacy-policy',path: '/profile/privacy-policy',getParentRoute: () => rootRouteImport
          })
const ProfileEditRoute = ProfileEditRouteImport.update({
            id: '/profile/edit',path: '/profile/edit',getParentRoute: () => rootRouteImport
          })
const PostIdRoute = PostIdRouteImport.update({
            id: '/post/$id',path: '/post/$id',getParentRoute: () => rootRouteImport
          })
const GroupIdRoute = GroupIdRouteImport.update({
            id: '/group/$id',path: '/group/$id',getParentRoute: () => rootRouteImport
          })
const DocumentIdRoute = DocumentIdRouteImport.update({
            id: '/document/$id',path: '/document/$id',getParentRoute: () => rootRouteImport
          })

const rootRouteChildren = {
  IndexRoute: IndexRoute,ChatRoute: ChatRoute,NotificationsRoute: NotificationsRoute,OfflineRoute: OfflineRoute,DocumentIdRoute: DocumentIdRoute,GroupIdRoute: GroupIdRoute,PostIdRoute: PostIdRoute,ProfileEditRoute: ProfileEditRoute,ProfilePrivacyPolicyRoute: ProfilePrivacyPolicyRoute,ProfileSettingsRoute: ProfileSettingsRoute,ProfileUserAgreementRoute: ProfileUserAgreementRoute,TopicIdRoute: TopicIdRoute,UserIdRoute: UserIdRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)